import { call, put, takeEvery, } from "redux-saga/effects";
import { RENTER_VIEW_PAYMENT } from "./actionTypes";
import { renterViewPaymentSuccessful, renterViewPaymentFailed } from "./action";
import { getPaymentList } from "../../../helpers/fakebackend_helper"
import { API_CODE } from '../../../helpers/enum'

function* renterViewPayment({ payload: { user } }) {

    try {
        const response = yield call(getPaymentList, user);
        if (response.statusCode === API_CODE.SUCCESS) {
            yield put(renterViewPaymentSuccessful(response.data));
        } else {
            yield put(renterViewPaymentFailed(response.message));
        }
    } catch (error) {
        yield put(renterViewPaymentFailed(error));
    }
}

function* RenterViewPaymentSaga() {
    yield takeEvery(RENTER_VIEW_PAYMENT, renterViewPayment);
}

export default RenterViewPaymentSaga;
